import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const PolicyPaperArticleIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 30,
  height = 30,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <g
        fill="none"
        fillRule="evenodd"
        stroke="none"
        strokeWidth="1"
        transform="translate(-173.000000, -46.000000)"
      >
        <g transform="translate(173.000000, 46.000000)">
          <path
            d="M-0.0001,15 C-0.0001,23.284 6.7159,30 14.9999,30 C23.2839,30 29.9999,23.284 29.9999,15 C29.9999,6.715 23.2839,0 14.9999,0 C6.7159,0 -0.0001,6.715 -0.0001,15"
            fill="#57B548"
          />
          <path
            d="M8.9999,22.352 C8.9999,22.862 9.4179,23.28 9.9279,23.28 L20.3459,23.28 C20.8559,23.28 21.2739,22.862 21.2739,22.352 L21.2739,11.082 C21.2739,10.572 20.9909,9.847 20.6449,9.472 L18.5489,7.199 C18.2029,6.824 17.5019,6.517 16.9919,6.517 L9.9279,6.517 C9.4179,6.517 8.9999,6.935 8.9999,7.445 L8.9999,22.352 Z"
            fill="#ffffff"
            className={styles.white}
          />
          <polyline
            points="17.9198 6.517 17.9198 10.164 21.2738 10.154"
            stroke="#57B548"
            strokeLinejoin="round"
            strokeWidth="0.5"
          />
          <polygon
            points="26.1361 9.6948 27.0001 10.5588 18.8271 18.7318 17.9631 17.8678"
            stroke="#57B548"
          />
          <polygon
            points="17.6854 19.5131 18.4054 19.1531 17.5414 18.2891 17.1814 19.0091"
            stroke="#57B548"
          />
          <polygon points="17.1815 19.0092 16.6775 20.0172 17.7415 19.4852" stroke="#57B548" />
          <polyline
            fill="#ffffff"
            className={styles.white}
            points="21.2738 14.5571 26.1358 9.6951 26.9998 10.5581 21.2738 16.2851"
          />
          <line
            stroke="#57B548"
            strokeLinejoin="round"
            strokeWidth="0.5"
            x1="11.33"
            x2="18.405"
            y1="11.8183"
            y2="11.8183"
          />
          <line
            stroke="#57B548"
            strokeLinejoin="round"
            strokeWidth="0.5"
            x1="11.33"
            x2="18.405"
            y1="15.5952"
            y2="15.5952"
          />
          <line
            stroke="#57B548"
            strokeLinejoin="round"
            strokeWidth="0.5"
            x1="11.33"
            x2="15.904"
            y1="17.4404"
            y2="17.4404"
          />
          <line
            stroke="#57B548"
            strokeLinejoin="round"
            strokeWidth="0.5"
            x1="11.33"
            x2="18.405"
            y1="13.7006"
            y2="13.7006"
          />
          <path
            d="M11.1351,21.1171 C11.3811,20.8711 11.6231,20.6231 11.8631,20.3721 C12.0501,20.1771 12.2351,19.9811 12.4171,19.7811 C12.5021,19.6861 12.5871,19.5911 12.6691,19.4941 C12.6991,19.4591 12.7281,19.4231 12.7571,19.3881 C12.7811,19.3571 12.8061,19.3261 12.8321,19.2961 C12.9091,19.2271 12.8771,19.2351 12.7341,19.3191 C12.6491,19.3261 12.5641,19.3331 12.4791,19.3401 C12.3731,19.3261 12.4491,19.3251 12.4371,19.4001 C12.4291,19.4461 12.4381,19.5001 12.4341,19.5481 C12.4251,19.6711 12.3981,19.7931 12.3701,19.9131 C12.3091,20.1761 12.2181,20.4301 12.1401,20.6881 C12.0771,20.8901 11.8291,21.4681 12.0561,21.6421 C12.2021,21.7541 12.4671,21.6841 12.6161,21.6221 C12.8411,21.5291 13.0091,21.3481 13.2231,21.2361 C13.4901,21.0961 13.7921,21.0081 14.0901,20.9771 C13.9931,20.9511 13.8961,20.9261 13.7991,20.9001 C13.9251,21.3031 14.1561,21.6931 14.6351,21.6011 C15.0571,21.5211 15.1641,21.2251 15.4231,20.9291 C15.5171,20.8221 15.6291,20.7221 15.7601,20.6611 C15.7941,20.6451 15.8241,20.6441 15.8201,20.6391 C15.8121,20.6311 15.7861,20.6471 15.8241,20.6391 C15.8521,20.6331 15.9171,20.6331 15.7651,20.6431 C15.9061,20.6341 16.1391,20.5981 16.2211,20.4631 C16.2981,20.3361 16.1551,20.2841 16.0431,20.2911 C15.5341,20.3251 15.0541,20.6011 14.7391,20.9971 C14.6751,21.0781 14.6021,21.1711 14.5571,21.2651 C14.5431,21.2861 14.5281,21.3061 14.5111,21.3251 C14.4261,21.4191 14.5311,21.4031 14.8261,21.2761 C14.7991,21.2191 14.6861,21.1481 14.6451,21.0811 C14.5771,20.9691 14.5251,20.8421 14.4861,20.7161 C14.4541,20.6131 14.2721,20.6311 14.1951,20.6391 C13.6951,20.6901 13.1761,20.8571 12.7401,21.1071 C12.6461,21.1601 12.3761,21.2881 12.3291,21.3921 C12.3371,21.3741 12.6541,21.4191 12.6751,21.3571 C12.6841,21.3291 12.6671,21.2481 12.6701,21.2131 C12.6941,20.9121 12.8171,20.6071 12.9081,20.3221 C13.0111,19.9991 13.1231,19.6591 13.1261,19.3171 C13.1291,19.0161 12.9291,18.9531 12.6541,19.0191 C12.3611,19.0891 12.2041,19.3041 12.0191,19.5211 C11.8421,19.7291 11.6551,19.9301 11.4681,20.1291 C11.1511,20.4661 10.8281,20.7971 10.5011,21.1241 C10.3841,21.2421 10.6021,21.2951 10.6791,21.2971 C10.8441,21.2991 11.0191,21.2331 11.1351,21.1171"
            stroke="#57B548"
          />
        </g>
      </g>
    </Icon>
  )
}
